export default "__VITE_PUBLIC_ASSET__e6626bd2__"